export default __webpack_public_path__ + "06837355f69945a7cc577ddc22272fd9.webp";